module.exports = __webpack_public_path__ + "img/1_newModelWorker_fsn.01fa68ea.png";